import React, { useEffect, useState } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function AdminAnalyticsTab() {
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/analytics/summary?days=14`);
        if (!response.ok) {
          throw new Error(`Unable to load analytics data from ${API_BASE_URL}/analytics/summary`);
        }
        const payload = await response.json();
        setSummary(payload);
      } catch (err) {
        setError(err.message || 'Unable to load analytics data');
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, []);

  if (loading) return <p>Loading analytics...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div>
      <h3>Analytics Overview</h3>
      <div style={{ display: 'grid', gap: '12px', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', marginBottom: '20px' }}>
        <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '12px' }}>
          <strong>Total Events</strong>
          <div>{summary?.totals?.total_events ?? 0}</div>
        </div>
        <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '12px' }}>
          <strong>Page Views</strong>
          <div>{summary?.totals?.page_views ?? 0}</div>
        </div>
        <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '12px' }}>
          <strong>Clicks</strong>
          <div>{summary?.totals?.clicks ?? 0}</div>
        </div>
        <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '12px' }}>
          <strong>New Sessions</strong>
          <div>{summary?.totals?.new_sessions ?? 0}</div>
        </div>
      </div>

      <h4>Daily trend</h4>
      <ul>
        {(summary?.timeline || []).map((item) => (
          <li key={item.date}>
            {item.date}: {item.total_events} events, {item.new_sessions} new sessions
          </li>
        ))}
      </ul>

      <h4>Top pages</h4>
      <ul>
        {(summary?.top_pages || []).map((item) => (
          <li key={item.page_path}>{item.page_path} — {item.count} views</li>
        ))}
      </ul>

      <h4>Top interactions</h4>
      <ul>
        {(summary?.top_interactions || []).map((item) => (
          <li key={`${item.event_name}-${item.element_text}`}>
            {item.element_text || item.event_name} — {item.count} events
          </li>
        ))}
      </ul>
    </div>
  );
}

export default AdminAnalyticsTab;
